export default __webpack_public_path__ + "static/media/csd_02.090fa307.png";